import { render, staticRenderFns } from "./LmDatatableWithModalSelector.vue?vue&type=template&id=60493eae&scoped=true&"
import script from "./LmDatatableWithModalSelector.vue?vue&type=script&lang=js&"
export * from "./LmDatatableWithModalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60493eae",
  null
  
)

export default component.exports